import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import confetti from 'canvas-confetti';

const API = process.env.REACT_APP_BACKEND_URL;

const fireAchievementConfetti = () => {
    // Smaller, classier burst than the push-welcome — celebrates a personal win
    const fire = (originX) => confetti({
        particleCount: 50,
        spread: 65,
        origin: { x: originX, y: 0.45 },
        colors: ['#10b981', '#f59e0b', '#3b82f6', '#a855f7'],
        scalar: 0.9,
    });
    fire(0.25);
    setTimeout(() => fire(0.75), 150);
};

export function useSmartComment() {
    const [comment, setComment] = useState(null);
    const [history, setHistory] = useState([]);

    const fetchComment = async (activityType, details = null, language = 'de') => {
        try {
            const res = await axios.post(`${API}/api/coach/smart-comment`, {
                activity_type: activityType,
                details: details,
                language: language
            });

            const c = res.data?.comment;
            const celebration = res.data?.celebration;
            if (c) {
                const short = c.length > 150 ? c.substring(0, 147) + '...' : c;
                setComment(c);
                // Achievement detected → fire confetti for the emotional payoff
                if (celebration) {
                    fireAchievementConfetti();
                }
                toast(short, {
                    duration: 6000,
                    icon: celebration ? '🎉' : '🐺',
                    style: { fontSize: '13px', lineHeight: '1.4', maxWidth: '340px' },
                    action: c.length > 150 ? {
                        label: 'Mehr',
                        onClick: () => toast(c, { duration: 15000, icon: '🐺', style: { fontSize: '12px', lineHeight: '1.4' } })
                    } : undefined
                });
            }
        } catch {
            // Silent fail
        }
    };

    const loadHistory = async (days = 7) => {
        try {
            const res = await axios.get(`${API}/api/coach/smart-comments?days=${days}`);
            setHistory(res.data?.comments || []);
        } catch {}
    };

    return { comment, history, fetchComment, loadHistory };
}
